/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Searchreadybadgetitle3Inputs */

const en_searchreadybadgetitle3 = /** @type {(inputs: Searchreadybadgetitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link from your website`)
};

const de_searchreadybadgetitle3 = /** @type {(inputs: Searchreadybadgetitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf deiner Website verlinken`)
};

/**
* | output |
* | --- |
* | "Link from your website" |
*
* @param {Searchreadybadgetitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const searchreadybadgetitle3 = /** @type {((inputs?: Searchreadybadgetitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Searchreadybadgetitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_searchreadybadgetitle3(inputs)
	return de_searchreadybadgetitle3(inputs)
});
export { searchreadybadgetitle3 as "searchReadyBadgeTitle" }